var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.loadedTags,"label":_vm.labelText,"dense":"","outlined":""},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedTag),callback:function ($$v) {_vm.selectedTag=$$v},expression:"selectedTag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }